import {
  calculateNDPPriceWithGST,
  calculateNetTotal,
  isInBulkCart,
} from "@/utils/helpers";
import { FormattedNumber } from "@/utils/numberFlow";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { HomeProduct } from "@/types/home";
import { useAppSelector } from "@/hooks/useAppSelector";

interface PriceDetailProps {
  handleChange: (
    id: string
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  product: HomeProduct;
  skuNDP_price: string;
  currentQuantity: number;
}

const PriceDetail: React.FC<PriceDetailProps> = ({
  handleChange,
  product,
  skuNDP_price,
  currentQuantity,
}) => {
  const { cart } = useAppSelector((state) => state.cart);
  return (
    <Accordion
      expanded={true}
      onChange={() => handleChange("pricing")}
      sx={{
        border: "1px solid #d9d9d9",
        borderRadius: "6px",
        boxShadow: "none",
        marginBottom: "10px",
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight="bold" fontSize="15px">
          Pricing Details
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          {[
            {
              label: "QTY",
              value: `${
                isInBulkCart(cart, product?.SKU_ID) ? currentQuantity : 0
              } units`,
            },
            {
              label: "Dealer Price",
              value: (
                <FormattedNumber
                  value={parseInt(
                    skuNDP_price ??
                      (currentQuantity &&
                      product?.Sales_Qunatity !== null &&
                      product?.Sales_Qunatity !== 0 &&
                      product?.Sales_Price !== null &&
                      Number(product?.Sales_Price) !== 0 &&
                      currentQuantity >= product?.Sales_Qunatity
                        ? product?.Sales_Price
                        : product.NDP_price)
                  )}
                />
              ),
            },
            { label: "GST", value: `${product.GST}%` },
            {
              label: "Dealer Price (Incl. GST)",
              value: (
                <FormattedNumber
                  value={calculateNDPPriceWithGST(
                    skuNDP_price ??
                      (currentQuantity &&
                      product?.Sales_Qunatity !== null &&
                      product?.Sales_Qunatity !== 0 &&
                      product?.Sales_Price !== null &&
                      Number(product?.Sales_Price) !== 0
                        ? product?.Sales_Price
                        : product.NDP_price),
                    product?.GST
                  )}
                />
              ),
            },
            {
              label: "Total",
              value: (
                <FormattedNumber
                  value={calculateNetTotal(
                    skuNDP_price ??
                      (currentQuantity &&
                      product?.Sales_Qunatity !== null &&
                      product?.Sales_Qunatity !== 0 &&
                      product?.Sales_Price !== null &&
                      Number(product?.Sales_Price) !== 0
                        ? product?.Sales_Price
                        : product.NDP_price),
                    product?.GST,
                    currentQuantity
                  )}
                />
              ),
              isBold: true,
            },
          ].map((item, index) => (
            <Grid container key={index} alignItems="center" mb={1}>
              <Grid item xs={5}>
                <Typography
                  variant="body2"
                  fontWeight={item.isBold ? "bold" : "600"}
                >
                  {item.label}
                </Typography>
              </Grid>
              <Grid item xs={2} display="flex" justifyContent="center">
                <Typography variant="body2" textAlign="center">
                  -
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography
                  variant="body2"
                  fontWeight={item.isBold ? "bold" : "600"}
                  textAlign="right"
                >
                  {item.value}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default PriceDetail;
